import { render, staticRenderFns } from "./PasswordManagerModals.vue?vue&type=template&id=0af3be2a&scoped=true&"
import script from "./PasswordManagerModals.vue?vue&type=script&lang=js&"
export * from "./PasswordManagerModals.vue?vue&type=script&lang=js&"
import style0 from "./PasswordManagerModals.vue?vue&type=style&index=0&id=0af3be2a&lang=sass&scoped=true&"
import style1 from "./PasswordManagerModals.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3be2a",
  null
  
)

export default component.exports